const ICON_TYPE = {
    DEFAULT: 'DEFAULT',
    ACTIVE: 'ACTIVE',
    HEADER: 'HEADER',
    EE0033: 'EE0033',
    CB002B: 'CB002B',
    PAGE_PRIMARY: 'PAGE_PRIMARY',
    PAGE_SECOND: 'PAGE_SECOND',
    ROW: 'ROW',
    TRANSPARENT: 'TRANSPARENT',
    606060: '606060',
    89294: "89294"
}

const ICON_COLOR = {
    DEFAULT: 'white',
    ACTIVE: '#AD0025',
    HEADER: '#44494D',
    EE0033: '#EE0033',
    CB002B: '#CB002B',
    ROW: '#949595',
    PAGE_PRIMARY: '#fff',
    PAGE_SECOND: '#ee0033',
    TRANSPARENT: 'transparent',
    606060: "#606060",
    89294: "#8F9294"
}

export { ICON_TYPE, ICON_COLOR }
